import { NgModule } from '@angular/core';
import { FriendInviteDialogComponent } from './friend-invite-dialog/friend-invite-dialog.component';
import { SharedModule } from '@shared/shared.module';
import { FriendInviteComponent } from './friend-invite.component';

@NgModule({
  declarations: [
    FriendInviteDialogComponent,
    FriendInviteComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    FriendInviteDialogComponent,
    FriendInviteComponent
  ]
})
export class FriendInviteModule { }
